import React, { useContext } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useNavigate } from 'react-router-dom';
import AccountDrawer from '../../Account/AccountDrawer/AccountDrawer';
import { AuthContext } from '../../../providers/AuthProvider';
import { COLOR_TOPBAR } from '../../../styles/tokens';
import { ROUTES } from '../../../config/constants';

export const TopBar = () => {
	const { user } = useContext(AuthContext);
	const navigate = useNavigate();

	return (
		<>
			<AppBar position="fixed" elevation={0}>
				<Toolbar
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						bgcolor: COLOR_TOPBAR,
					}}
				>
					<div>{user && <div style={{ width: '28px' }} />}</div>
					<img
						src={process.env.PUBLIC_URL + '/LogoWhite.png'}
						alt="Fore Edge Book Art"
						style={{
							maxWidth: '50px',
							maxHeight: '50px',
							cursor: 'pointer',
						}}
						onClick={() => navigate(ROUTES.ABOUT)}
					/>
					<div>{user && <AccountDrawer />}</div>
				</Toolbar>
			</AppBar>
			<Toolbar />
		</>
	);
};
